export default "__VITE_ASSET__05ba24fe__"